import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.6_@babel+core@7.24.9_supports-color@9.4.0__@opentelemetry+api@1.9.0_@playwright+tes_c3sxq47vzk56jnxwdkpnsxvc4i/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["CategorySectionInner"] */ "/vercel/path0/web/src/components/categories/categories-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadCrumbNavBar"] */ "/vercel/path0/web/src/components/navigation/breadcrumb-navbar.tsx");
